const mutations = {
  //  修改区域列表
  SET_DANGERLIST: (state, val) => { state.dangerList = val },
  //  修改加载状态
  SET_LOADING: (state, val) => { state.loading = val },
  //  修改摄像头
  SET_CAMERA: (state,val) => { state.cameraInfo = val },
// 添加tabs
      add_tabs: (state, data) => {
        for(let item of state.openTab){
            if(item.route === data.route){
              return true;
            }
          }
          state.openTab.push(data);
        
      },
      // 删除tabs
      delete_tabs: (state, route) => {
        let index = 0;
        for (let option of state.openTab) {
          if (option.route === route) {
            break;
          }
          index++;
        }
        state.openTab.splice(index, 1);
      },
      // 设置当前激活的tab
      set_active_index: (state, index) => {
        state.activeIndex = index;
      }
}
export default mutations